import { useEffect, useState } from 'react';
import { downloadUrlForStoragePath } from './cloudProjects';
import { writesStayLocal } from './localOnly';
import { storagePathFromContentUrl } from './picturePaths';

/** Picture URL for an <img>. Localhost keeps /content. The live site uses Storage. */
export function useStoredPicture(contentUrl) {
  const local = writesStayLocal();
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (!contentUrl) {
      setSrc('');
      return undefined;
    }
    if (local) {
      setSrc(contentUrl);
      return undefined;
    }
    let cancel = false;
    const storagePath = storagePathFromContentUrl(contentUrl);
    if (!storagePath) {
      setSrc('');
      return undefined;
    }
    downloadUrlForStoragePath(storagePath).then((url) => {
      if (!cancel) setSrc(url || '');
    });
    return () => {
      cancel = true;
    };
  }, [contentUrl, local]);

  return src;
}
